import { BYE } from "../../../publicFunctions/adminDuelHandler";
import {
  getFontStyle,
  getPositionOfStoriesInMatchBox,
  isFinalistLane,
  TBD,
} from "../../../publicFunctions/publicHelpers/tournamentViewHelper";
import { addStoryContainerToPayload } from "./addStoryContainerToPayload";

export function addMatchToPayload(
  finalShowdown,
  payload,
  sizes,
  match,
  centeredMatchPos,
  lane,
  row,
  zoomLevel,
  matchBoxClass,
  nightMode,
  mutedUsers,
  isLaneOnLeft,
  battleId
) {
  //   MATCH BOX LINES
  payload.push(
    <div
      style={{
        position: "absolute",
        width: sizes.matchBoxW.toString(10) + "px",
        height: sizes.matchBoxH.toString(10) + "px",
        top: centeredMatchPos.y,
        left: centeredMatchPos.x,
        borderRadius: sizes.matchBoxRadius,
        boxShadow: sizes.matchBoxShadow,
        transition: "box-shadow 0.2s, border-radius 0.2s",
        background: nightMode
          ? "rgba(34,34,34,0.97)"
          : "rgba(255,255,255,0.97)",
      }}
      className={matchBoxClass}
      key={"match_" + lane.toString(10) + "_" + row.toString(10)}
    ></div>
  );

  const storyPositions = getPositionOfStoriesInMatchBox(
    centeredMatchPos,
    sizes.storyBoxH,
    sizes.versusBoxH,
    sizes.smallPadding
  );

  // TOP STORY
  addStoryContainerToPayload(
    finalShowdown,
    true,
    match,
    payload,
    zoomLevel,
    storyPositions,
    nightMode,
    sizes,
    mutedUsers,
    matchBoxClass,
    lane,
    row,
    isLaneOnLeft,
    battleId
  );

  {
    /* VERSUS */
  }
  if (
    match.topStoryId &&
    match.topStoryId !== BYE &&
    match.bottomStoryId &&
    match.bottomStoryId !== BYE &&
    match.topStoryId !== TBD &&
    match.bottomStoryId !== TBD
  ) {
    payload.push(
      <div
        style={{
          position: "absolute",
          width: sizes.storyBoxW.toString(10) + "px",
          height: sizes.versusBoxH.toString(10) + "px",
          top: storyPositions.versusY,
          left: storyPositions.versusX,
        }}
        key={"versus_" + lane.toString(10) + "_" + row.toString(10)}
      >
        <div style={{ position: "relative" }}>
          <p
            style={getFontStyle(
              sizes.largeFontSize,
              sizes.storyBoxW,
              sizes.storyBoxH,
              nightMode,
              true
            )}
          >
            VS
          </p>
        </div>
      </div>
    );
  }

  // BOTTOM STORY
  addStoryContainerToPayload(
    finalShowdown,
    false,
    match,
    payload,
    zoomLevel,
    storyPositions,
    nightMode,
    sizes,
    mutedUsers,
    matchBoxClass,
    lane,
    row,
    isLaneOnLeft,
    battleId
  );

  // Winner Display
  if (
    isFinalistLane(lane, sizes.numberOfLanes) &&
    match.winner &&
    match.winner !== BYE &&
    match.winner !== TBD
  ) {
    addStoryContainerToPayload(
      finalShowdown,
      match.topStoryId === match.winner,
      match,
      payload,
      zoomLevel,
      storyPositions,
      nightMode,
      sizes,
      mutedUsers,
      matchBoxClass,
      lane,
      row,
      isLaneOnLeft,
      battleId,
      true
    );
  }
}
